// src/i18n/privacy/getPrivacy.js

import {
  privacyTranslations,
  normalizePrivacyLang,
} from './index';

/**
 * Вернуть целиком объект политики для нужного языка
 */
export function getPrivacy(lang = 'en') {
  const code = normalizePrivacyLang(lang);
  return privacyTranslations[code] || privacyTranslations.en;
}

/**
 * Вернуть конкретную строку политики по ключу.
 * Порядок аргументов такой, как ты используешь в UI: (key, lang).
 *
 * Пример:
 *   getPrivacyText('privacy.header.title', 'ru')
 */
export function getPrivacyText(key, lang = 'en') {
  const bundle = getPrivacy(lang);

  if (!bundle || !key) return key;

  // точное совпадение
  if (Object.prototype.hasOwnProperty.call(bundle, key)) {
    return bundle[key];
  }

  // пробуем ключ без лишних пробелов
  const trimmed = key.trim();
  if (
    trimmed !== key &&
    Object.prototype.hasOwnProperty.call(bundle, trimmed)
  ) {
    return bundle[trimmed];
  }

  // fallback на en
  const enBundle = privacyTranslations.en;
  if (enBundle && Object.prototype.hasOwnProperty.call(enBundle, key)) {
    return enBundle[key];
  }
  if (
    enBundle &&
    trimmed !== key &&
    Object.prototype.hasOwnProperty.call(enBundle, trimmed)
  ) {
    return enBundle[trimmed];
  }

  // вообще нигде нет — вернём сам ключ (удобно для отладки)
  return key;
}
